var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLookupIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9997 1.66666C16.1503 1.66666 17.083 2.59941 17.083 3.75V15.625C17.083 15.9702 16.8032 16.25 16.458 16.25H4.58301C4.58301 16.7102 4.95611 17.0833 5.41634 17.0833H16.458C16.8032 17.0833 17.083 17.3632 17.083 17.7083C17.083 18.0535 16.8032 18.3333 16.458 18.3333H5.41634C4.26575 18.3333 3.33301 17.4006 3.33301 16.25V3.75C3.33301 2.59941 4.26575 1.66666 5.41634 1.66666H14.9997ZM14.9997 2.91666H5.41634C4.95611 2.91666 4.58301 3.28976 4.58301 3.75V15H15.833V3.75C15.833 3.28976 15.4599 2.91666 14.9997 2.91666ZM9.76942 5C11.4832 5 12.8725 6.38929 12.8725 8.10306C12.8725 8.74166 12.6793 9.33566 12.3484 9.82916L14.4063 11.8872C14.6419 12.1227 14.6419 12.5045 14.4063 12.74C14.1922 12.9542 13.8572 12.9735 13.6209 12.7982L13.6148 12.7937L13.5589 12.7454L11.4955 10.6821C11.002 11.013 10.408 11.2062 9.76942 11.2062C8.05563 11.2062 6.66634 9.81683 6.66634 8.10306C6.66634 6.38929 8.05563 5 9.76942 5ZM9.76942 6.20614C8.72176 6.20614 7.87248 7.05542 7.87248 8.10306C7.87248 9.15075 8.72176 10 9.76942 10C10.8171 10 11.6663 9.15075 11.6663 8.10306C11.6663 7.05542 10.8171 6.20614 9.76942 6.20614Z",
    fill: "#313131"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLookupIcon);
export default __webpack_public_path__ + "static/media/lookup-icon.226a7361590d10703b570c99d5188993.svg";
export { ForwardRef as ReactComponent };